import React from 'react';
import Ajv from 'ajv';
// import { bindActionCreators } from 'redux';
import { connect} from 'react-redux';

import {
  timeoutPromiseAt,
  RxSubjRegistrar,
  makeFuncDebounceSwitchMapViaRxSubj,
} from 'shared/helpers';
import {
  startMenuIsSubmitting,
} from 'shared/actions/view/web';

import {
  processInputLocallyForUpdate,
  initFormDataBySchema,
  partitionFormDataByAttr,
  compactFormDataVal,
} from 'helpers/formHelper';
import { withNotify } from 'components/hocs';


// TODO(tyu): prefix actions with "_" to indicate dispatch?
// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     startMenuIsSubmitting,
//   }, dispatch);
// };



export default function manageUserAuthForm(jsonSchema, validators = {}) {
  return (UserAuthForm) => {
    class UserAuthFormManaged extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          formData: initFormDataBySchema(jsonSchema),
          respData: {},  // Response to submission
          isSubmitting: false,
        };

        const {
          validateWithApolloClientFuncMap = {},
        } =  validators;
        this.validateWithApolloClientFuncMap = validateWithApolloClientFuncMap;

        this.handleInputOnFocus = this.handleInputOnFocus.bind(this);
        this.handleInputOnChange = this.handleInputOnChange.bind(this);
        this.handleInputOnBlur = this.handleInputOnBlur.bind(this);
        this.takeInputEventForUpdate = this.takeInputEventForUpdate.bind(this);
        this.validateFormData = this.validateFormData.bind(this);
        this.submitForm = this.submitForm.bind(this);

        // JSON Schema validator.
        this.ajv = new Ajv();

        // Use RxJS to manage debouncing of input validation.
        this.rxSubjRegistrar = new RxSubjRegistrar();
        this.rxSubjRegistrar.reset();
      }

      componentDidUpdate(prevProps, prevState) {
        // Sync stateMenu state automatically via redux.
        if (prevState.isSubmitting !== this.state.isSubmitting) {
          const { isSubmitting } = this.state;
          this.props.startMenuIsSubmitting({ isSubmitting });
        }
      }

      handleInputOnFocus(e) {
        const opts = {canIgnorePresenceReq: true};
        this.relayInputEventForUpdate(e, opts);
      }

      handleInputOnChange(e) {
        // When editing on focus, debounce validation.
        const opts = {
          canIgnorePresenceReq: true,
          viaRxSubjSubscribeFunc: makeFuncDebounceSwitchMapViaRxSubj(350),
        };
        this.relayInputEventForUpdate(e, opts);
      }

      handleInputOnBlur(e) {
        this.relayInputEventForUpdate(e);
      }

      relayInputEventForUpdate(e, opts = {}) {
        const {name, value, dataset} = e.target;
        const _opts = {...dataset, ...opts};
        const args = {
          schema: jsonSchema,
          inputName: name,
          inputValue: value,
          opts: _opts
        };

        const key = name;
        const subscribeFunc = args.opts.viaRxSubjSubscribeFunc;
        if (subscribeFunc) {
          const onNextFunc = this.takeInputEventForUpdate;
          this.rxSubjRegistrar.callViaSubj(key, subscribeFunc, onNextFunc, args);

          // Immediately update for the value update.
          this.mergeStateFormData({
            [name]: {value, errors: []},
          });

          return;
        }

        this.rxSubjRegistrar.castViaSubj(key, args);
        this.takeInputEventForUpdate(args);
      }

      takeInputEventForUpdate({schema, inputName, inputValue, opts}) {
        const updateToFormData = processInputLocallyForUpdate(schema, inputName, inputValue, opts);

        // Validate remotely with Apollo if value is locally valid.
        const { errors } = updateToFormData[inputName];
        const isValidLocally = errors.length === 0;
        if (isValidLocally && inputValue.trim()) {
          this.validateInputRemotelyAndUpdate({schema, inputName, inputValue, opts});
        }

        this.mergeStateFormData(updateToFormData);
      }

      validateInputRemotelyAndUpdate({inputName, inputValue}) {
        const validateWithApolloClientFunc = this.validateWithApolloClientFuncMap[inputName];
        if (!validateWithApolloClientFunc) {
          return;
        }

        // NOTE: Expect the presence of `errors` in data response.
        const payloadKey = validateWithApolloClientFunc.payloadKey;
        const respHandler = ({ data: {[payloadKey]: payload} }) => {
          if (payload.errors.length === 0) {
            // No errors, noop.
            return;
          }

          const newErrMsgs = payload.errors
            .filter( ({ key, message }) => key === inputName)
            .map( ({ key, message }) => message);

          // If errors, merge them into the current state for input.
          const { [inputName]: inputObj } = this.state.formData;
          this.mergeStateFormData({
            [inputName]: {
              value: inputObj.value,
              errors: [...inputObj.errors, ...newErrMsgs],
            }
          });
        };

        const variables = {[inputName]: inputValue};
        validateWithApolloClientFunc(this.props.client, variables)
          .then(respHandler);
      }

      mergeStateFormData(updateToFormData) {
        const formData = {...this.state.formData, ...updateToFormData};
        this.setState({formData});
      }

      validateFormData() {
        const {
          formDataVal,
          formDataErr
        } = partitionFormDataByAttr(this.state.formData);

        // Remove any empty inputs.
        const formDataValCompact = compactFormDataVal(formDataVal);

        return (
          Object.keys(formDataErr).length === 0 &&
          this.ajv.validate(jsonSchema, formDataValCompact)
        );
      }

      submitForm() {
        const submitFunc = this.props['submitFunc'];
        if (typeof submitFunc !== 'function') {
          // Parent component has to pass in a callback func named
          // 'submitFunc' that expects an object of formData values
          // as an only arg; otherwise noop.
          return;
        }

        const { formDataVal } = partitionFormDataByAttr(this.state.formData);

        this.setState({ isSubmitting: true, respData: {} });
        timeoutPromiseAt(5000, submitFunc(formDataVal))
          .then(resp => {
            this.setState({ isSubmitting: false, respData: resp.data });
          }).catch(err => {
            this.setState({ isSubmitting: false, respData: {} });

            // TODO: Need to report error here
            const message =  'Oops, something went wrong. Try again later?';
            this.props.notifyError(message);
          });
      }

      render() {
        return (
          <UserAuthForm
            formData={this.state.formData}
            respData={this.state.respData}
            handleInputOnFocus={this.handleInputOnFocus}
            handleInputOnChange={this.handleInputOnChange}
            handleInputOnBlur={this.handleInputOnBlur}
            validateFormData={this.validateFormData}
            submitForm={this.submitForm}
            isSubmitting={this.state.isSubmitting}
            {...this.props}
          />
        );
      }
    }

    return withNotify(connect(null, { startMenuIsSubmitting })(UserAuthFormManaged));
  };
}


// Common apollo mutate config for auth forms.
export const gqlSubmitFormCfg = {
  props: ({mutate}) => ({
    // NOTE: Must be named `submitFunc`, as looked up by UserAuthFormManaged.
    submitFunc: (formDataVal) => mutate({
      variables: {input: formDataVal},
    }),
  }),
};



// WEBPACK FOOTER //
// ./src/components/forms/manageUserAuthForm.js